export class RegelSet {
  regelSetId: number;
  naam: string;
}
